import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { loadFiltersFromStorage } from 'features/globalFilters/globalFiltersStorage';
import { reduxSoldierMiddleware } from 'redux-soldier';
import globalFiltersMiddleware from 'features/globalFilters/globalFiltersMiddleware';
import rootReducer from 'store/reducer';

const devtools =
  typeof composeWithDevTools === 'function'
    ? composeWithDevTools
    : compose;

const enhancer =
  process.env.NODE_ENV === 'development'
    ? devtools(applyMiddleware(reduxSoldierMiddleware, globalFiltersMiddleware))
    : compose(applyMiddleware(reduxSoldierMiddleware, globalFiltersMiddleware));

const preloadedState = {
  globalFilters: {
    applied: loadFiltersFromStorage(),
    notAppliedFilters: [],
    tableauAppliedFilterValues: {},
    defaultsSeeded: false
  }
};

export const store = createStore(
  rootReducer,
  preloadedState,
  enhancer
);
